module.exports = __webpack_public_path__ + "img/comment4.6f878047.png";